import React from 'react'

import * as Grid from '../../Grid'

import {
  FooterContainer,
  Copyright,
  CopyrightSmall,
  Title,
  Ul,
  LinkCustom
} from './style'

import logoFooter from '../../../images/home/skypostal-logo-footer.png'

function Footer() {
  const today = new Date()
  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Column>
          <FooterContainer>
            <div>
              <img src={logoFooter} alt={logoFooter} />
              <Copyright>
                <CopyrightSmall>
                  Copyright © {today.getFullYear()}.
                </CopyrightSmall>
                <CopyrightSmall>All Rights Reserved.</CopyrightSmall>
              </Copyright>
            </div>
            {/* <div>
              <Title>Features</Title>
              <Ul>
                <li>
                  <LinkCustom href="#cool-stuff">Cool stuff</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#random-feature">Random feature</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#team-feature">Team feature</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#stuff-developers">
                    Stuff of developers
                  </LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#another-one">Another one</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#last-time">Last time</LinkCustom>
                </li>
              </Ul>
            </div> */}
            {/* <div>
              <Title>Resources</Title>
              <Ul>
                <li>
                  <LinkCustom href="#resource">Resource</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#resource-name">Resource Name</LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#another-resource">
                    Another Resource
                  </LinkCustom>
                </li>
                <li>
                  <LinkCustom href="#final-resource">Final Resource</LinkCustom>
                </li>
              </Ul>
            </div> */}
            <div>
              <Title>About</Title>
              <Ul>
                <li>
                  <LinkCustom
                    href="https://www.skypostal.com/about-us"
                    target="_blank"
                  >
                    About Us
                  </LinkCustom>
                </li>
                <li>
                  <LinkCustom
                    href="https://www.skypostal.com/faqs"
                    target="_blank"
                  >
                    FAQs
                  </LinkCustom>
                </li>
                <li>
                  <LinkCustom
                    href="https://www.skypostal.com/privacy"
                    target="_blank"
                  >
                    Privacy Policy
                  </LinkCustom>
                </li>
                <li>
                  <LinkCustom
                    href="https://www.skypostal.com/terms-conditions"
                    target="_blank"
                  >
                    Terms and Conditions
                  </LinkCustom>
                </li>
              </Ul>
            </div>
          </FooterContainer>
        </Grid.Column>
      </Grid.Row>
    </Grid.Container>
  )
}

export default Footer
